





















/** @format */

import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class RuleWrapByDataPattern extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  datePattern!: string;
}
